// import React, { useEffect, useState } from 'react';
// import {
//   Modal,
//   Form,
//   Select,
//   Input,
//   Button,
//   Typography,
//   Avatar,
//   Progress,
//   Switch
// } from 'antd';
// import { useDispatch, useSelector } from 'react-redux';
// import ColorHash from 'color-hash';
// import { getAllUsers } from 'pages/Tasks/redux/slice';
// import {
//   assignProjectToUser,
//   fetchStaffingData,
//   fetchStaffingUsers
//   // selectStaffingSlice
// } from '../redux/slice';

// import { selectStaffingSlice } from 'pages/PlanStaffing/redux/slice';

// const { Text } = Typography;
// const { Option } = Select;
// const colorHash = new ColorHash({ lightness: 0.7 });

// const getInitials = (name) => {
//   if (!name) return 'U';
//   return name
//     .split(' ')
//     .map((word) => word[0])
//     .join('')
//     .toUpperCase();
// };
// const AddMemberModal = ({
//   visible,
//   open,
//   onClose,
//   onSubmit,
//   projectsData = [],
//   project
// }) => {
//   const [form] = Form.useForm();
//   const isOpen = visible || open;
//   const dispatch = useDispatch();

//   const [users, setUsers] = useState([]);
//   const [utilizationType, setUtilizationType] = useState('active');
//   const [currentUtilization, setCurrentUtilization] = useState(null);
//   const [allocationValue, setAllocationValue] = useState(0);

//   const { staffAssignments } = useSelector(selectStaffingSlice);
//   console.log(staffAssignments, 'staffAssignments');
//   const availableUtilization = Math.max(0, 100 - currentUtilization);

//   useEffect(() => {
//     if (isOpen) {
//       dispatch(getAllUsers()).then((res) => {
//         if (res?.payload?.success) {
//           setUsers(res.payload.data || []);
//         }
//       });
//     }
//   }, [dispatch, isOpen]);

//   useEffect(() => {
//     if (isOpen && project) {
//       form.setFieldsValue({
//         project: project.projectTitle,
//         client: project.company
//       });
//     } else {
//       form.resetFields();
//       setCurrentUtilization(null);
//     }
//   }, [isOpen, project, form]);

//   const handleUserSelect = (userId) => {
//     const userData = staffAssignments.find((u) => u.user_id === userId);
//     setCurrentUtilization(userData?.total_utilization ?? 0);
//   };

//   const handleFinish = (values) => {
//     const payload = {
//       project_id: project?.projectId,
//       user_id: values.employee,
//       utilization_type: utilizationType,
//       utilization_percentage: Number(values.utilization)
//     };

//     console.log('Payload to assign:', payload);
//     dispatch(assignProjectToUser(payload)).then((res) => {
//       if (res?.payload?.success) {
//         dispatch(fetchStaffingData());
//         dispatch(fetchStaffingUsers());
//       }
//     });
//     onClose();
//     form.resetFields();
//     setCurrentUtilization(null);
//   };

//   const handleCancel = () => {
//     form.resetFields();
//     setCurrentUtilization(null);
//     onClose();
//   };

//   const getUtilizationColor = () => {
//     if (currentUtilization < 50) return '#52c41a'; // green
//     if (currentUtilization < 80) return '#faad14'; // yellow
//     return '#ff4d4f'; // red
//   };

//   return (
//     <Modal
//       visible={isOpen}
//       // title="Add Member"
//       onCancel={handleCancel}
//       footer={null}
//       centered
//       destroyOnClose={true}
//       maskClosable={true}
//       width={500}
//     >
//       <Form form={form} layout="vertical" onFinish={handleFinish}>
//         <h3 className="text-[rgba(0,0,0,0.85)]" style={{ fontWeight: 'bold' }}>
//           Add Member
//         </h3>
//         <Form.Item
//           label="Select Member"
//           name="employee"
//           rules={[{ required: true, message: 'Please select an Member' }]}
//           style={{
//             fontSize: '11px',
//             color: '#595959',
//             fontWeight: 600,
//             paddingBottom: 0
//           }}
//         >
//           <Select
//             placeholder="Select an Member"
//             showSearch
//             optionFilterProp="children"
//             onChange={handleUserSelect}
//             style={{ fontWeight: 100 }}
//           >
//             {users.map((user) => (
//               <Option key={user.id} value={user.id}>
//                 <Avatar
//                   size="small"
//                   style={{
//                     backgroundColor: colorHash.hex(
//                       `${user.first_name} ${user.last_name}`
//                     ),
//                     marginRight: 8,
//                     color: '#fff'
//                   }}
//                 >
//                   {getInitials(`${user.first_name} ${user.last_name}`)}
//                 </Avatar>
//                 {user.first_name} {user.last_name}
//               </Option>
//             ))}
//           </Select>
//         </Form.Item>

//         {currentUtilization !== null && (
//           <div
//             style={{
//               marginBottom: 16,
//               border: '1px solid #D1D5DB',
//               padding: '6px 10px',
//               borderRadius: '10px'
//             }}
//           >
//             <Text>Current Utilization</Text>
//             <Progress
//               percent={currentUtilization}
//               status="active"
//               showInfo={false}
//               strokeColor={getUtilizationColor()}
//               style={{ marginTop: 4 }}
//             />
//             <div
//               style={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 fontSize: 12,
//                 marginTop: 4
//               }}
//             >
//               <Text type="secondary">Available: {availableUtilization}%</Text>
//               <Text type="secondary">Current: {currentUtilization}%</Text>
//             </div>
//           </div>
//         )}

//         <Form.Item
//           label={`Utilization (Max: ${availableUtilization}%)`}
//           name="utilization"
//           validateStatus={
//             allocationValue > availableUtilization ? 'warning' : undefined
//           }
//           help={
//             allocationValue > availableUtilization
//               ? `⚠ Utilization exceeds available limit of ${availableUtilization}%`
//               : null
//           }
//           rules={[
//             { required: true, message: 'Please enter utilization percentage' },
//             {
//               type: 'number',
//               min: 1,
//               message: 'Must be at least 1%'
//             }
//           ]}
//           getValueFromEvent={(e) => {
//             const val = Number(e.target.value);
//             setAllocationValue(val);
//             return val;
//           }}
//         >
//           <Input
//             type="number"
//             placeholder="Enter Utilization"
//             min={1}
//             addonAfter="%"
//           />
//         </Form.Item>

//         <Form.Item label="Project" name="project">
//           <Input disabled placeholder="Project Name" />
//         </Form.Item>

//         <Form.Item label="Client" name="client">
//           <Input disabled placeholder="Client Name" />
//         </Form.Item>

//         {/* <Form.Item label="Utilization Type">
//           <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
//             <span
//               style={{
//                 color: utilizationType === 'active' ? '#1890ff' : '#595959'
//               }}
//             >
//               Active
//             </span>
//             <Switch
//               checked={utilizationType === 'upcoming'}
//               onChange={(checked) =>
//                 setUtilizationType(checked ? 'upcoming' : 'active')
//               }
//             />
//             <span
//               style={{
//                 color: utilizationType === 'upcoming' ? '#1890ff' : '#595959'
//               }}
//             >
//               Upcoming
//             </span>
//           </div>
//         </Form.Item> */}
//         <Form.Item label="Utilization Type">
//           <Button.Group>
//             <Button
//               type={utilizationType === 'active' ? 'primary' : 'default'}
//               onClick={() => setUtilizationType('active')}
//             >
//               Active
//             </Button>
//             <Button
//               type={utilizationType === 'upcoming' ? 'primary' : 'default'}
//               onClick={() => setUtilizationType('upcoming')}
//             >
//               Upcoming
//             </Button>
//           </Button.Group>
//         </Form.Item>

//         <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
//           <Button
//             onClick={handleCancel}
//             className="font-bold border border-blue-500 text-blue-500"
//           >
//             Cancel
//           </Button>
//           <Button className="font-bold" type="primary" htmlType="submit">
//             Add Member
//           </Button>
//         </div>
//       </Form>
//     </Modal>
//   );
// };

// export default AddMemberModal;

import React, { useEffect, useState } from 'react';
import {
  Modal,
  Form,
  Select,
  Input,
  Button,
  Typography,
  Avatar,
  Progress,
  Checkbox,
  Radio
} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import ColorHash from 'color-hash';
import { getAllUsers } from 'pages/Tasks/redux/slice';
import {
  assignProjectToUser,
  fetchStaffingData,
  fetchStaffingUsers,
  fetchUserRoles // ✅ import roles API
} from '../redux/slice';

import { selectStaffingSlice } from 'pages/PlanStaffing/redux/slice';

const { Text } = Typography;
const { Option } = Select;
const colorHash = new ColorHash({ lightness: 0.7 });

const getInitials = (name) => {
  if (!name) return 'U';
  return name
    .split(' ')
    .map((word) => word[0])
    .join('')
    .toUpperCase();
};

const AddMemberModal = ({
  visible,
  open,
  onClose,
  onSubmit,
  projectsData = [],
  project
}) => {
  const [form] = Form.useForm();
  const isOpen = visible || open;
  const dispatch = useDispatch();

  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]); // ✅ roles state
  const [utilizationType, setUtilizationType] = useState('active');
  const [currentUtilization, setCurrentUtilization] = useState(null);
  const [allocationValue, setAllocationValue] = useState(0);

  const { staffAssignments } = useSelector(selectStaffingSlice);
  const availableUtilization = Math.max(0, 100 - currentUtilization);

  useEffect(() => {
    if (isOpen) {
      dispatch(getAllUsers()).then((res) => {
        if (res?.payload?.success) {
          setUsers(res.payload.data || []);
        }
      });
      dispatch(fetchUserRoles()).then((res) => {
        if (res?.payload?.success) {
          setRoles(res.payload.data || []);
        }
      });
    }
  }, [dispatch, isOpen]);

  useEffect(() => {
    if (isOpen && project) {
      form.setFieldsValue({
        project: project.projectTitle,
        client: project.company
      });
    } else {
      form.resetFields();
      setCurrentUtilization(null);
    }
  }, [isOpen, project, form]);

  const handleUserSelect = (userId) => {
    const userData = staffAssignments.find((u) => u.user_id === userId);
    setCurrentUtilization(userData?.total_utilization ?? 0);
  };

  const handleFinish = (values) => {
    const payload = {
      project_id: project?.projectId,
      user_id: values.employee,
      project_role_master_id: values.role, // ✅ role id
      utilization_type: utilizationType,
      utilization_percentage: Number(values.utilization)
    };

    console.log('Payload to assign:', payload);
    dispatch(assignProjectToUser(payload)).then((res) => {
      if (res?.payload?.success) {
        dispatch(fetchStaffingData());
        dispatch(fetchStaffingUsers());
      }
    });
    onClose();
    form.resetFields();
    setCurrentUtilization(null);
  };

  const handleCancel = () => {
    form.resetFields();
    setCurrentUtilization(null);
    onClose();
  };

  const getUtilizationColor = () => {
    if (currentUtilization < 50) return '#52c41a';
    if (currentUtilization < 80) return '#faad14';
    return '#ff4d4f';
  };

  return (
    <Modal
      visible={isOpen}
      onCancel={handleCancel}
      footer={null}
      centered
      destroyOnClose
      maskClosable
      width={500}
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <h3
          className="text-[rgba(0,0,0,0.85)]"
          style={{ fontWeight: 'bold', marginTop: '-7px' }}
        >
          Add Member
        </h3>

        {/* Member Selection */}
        <Form.Item
          label="Select Member"
          name="employee"
          rules={[{ required: true, message: 'Please select a member' }]}
        >
          <Select
            placeholder="Select a Member"
            showSearch
            optionFilterProp="children"
            onChange={handleUserSelect}
          >
            {users.map((user) => (
              <Option key={user.id} value={user.id}>
                <Avatar
                  size="small"
                  style={{
                    backgroundColor: colorHash.hex(
                      `${user.first_name} ${user.last_name}`
                    ),
                    marginRight: 8,
                    color: '#fff'
                  }}
                >
                  {getInitials(`${user.first_name} ${user.last_name}`)}
                </Avatar>
                {user.first_name} {user.last_name}
              </Option>
            ))}
          </Select>
        </Form.Item>

        {/* Role Selection
        <Form.Item
          label="Role"
          name="role"
          rules={[{ required: true, message: 'Please select a role' }]}
        >
          <Select placeholder="Select a Role" showSearch>
            {roles.map((role) => (
              <Option key={role.id} value={role.id}>
                {role.role}
              </Option>
            ))}
          </Select>
        </Form.Item> */}

        {/* Utilization Section */}
        {currentUtilization !== null && (
          <div
            style={{
              marginBottom: 16,
              border: '1px solid #D1D5DB',
              padding: '6px 10px',
              borderRadius: '10px'
            }}
          >
            <Text>Current Utilization</Text>
            <Progress
              percent={currentUtilization}
              status="active"
              showInfo={false}
              strokeColor={getUtilizationColor()}
              style={{ marginTop: 4 }}
            />
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                fontSize: 12,
                marginTop: 4
              }}
            >
              <Text type="secondary">Available: {availableUtilization}%</Text>
              <Text type="secondary">Current: {currentUtilization}%</Text>
            </div>
          </div>
        )}

        <Form.Item
          label={`Utilization (Max: ${availableUtilization}%)`}
          name="utilization"
          validateStatus={
            allocationValue > availableUtilization ? 'warning' : undefined
          }
          help={
            allocationValue > availableUtilization
              ? `⚠ Utilization exceeds available limit of ${availableUtilization}%`
              : null
          }
          rules={[
            { required: true, message: 'Please enter utilization percentage' },
            {
              type: 'number',
              min: 1,
              message: 'Must be at least 1%'
            }
          ]}
          getValueFromEvent={(e) => {
            const val = Number(e.target.value);
            setAllocationValue(val);
            return val;
          }}
        >
          <Input
            type="number"
            placeholder="Enter Utilization"
            min={1}
            addonAfter="%"
          />
        </Form.Item>

        {/* Role Selection */}
        <Form.Item
          label="Role"
          name="role"
          rules={[{ required: true, message: 'Please select a role' }]}
        >
          <Select placeholder="Select a Role" showSearch>
            {roles.map((role) => (
              <Option key={role.id} value={role.id}>
                {role.role}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item label="Project" name="project">
          <Input disabled placeholder="Project Name" />
        </Form.Item>

        <Form.Item label="Client" name="client">
          <Input disabled placeholder="Client Name" />
        </Form.Item>

        <Form.Item label="Utilization Type">
          <div className="flex gap-2">
            <Button
              style={{
                height: '24px',
                padding: '0px 10px 5px',
                backgroundColor:
                  utilizationType === 'active' ? '#0653fa' : undefined, // green
                color: utilizationType === 'active' ? 'white' : undefined,
                borderColor:
                  utilizationType === 'active' ? '#0653fa' : undefined
              }}
              type={utilizationType === 'active' ? 'default' : 'default'}
              onClick={() => setUtilizationType('active')}
            >
              Active
            </Button>
            <Button
              style={{
                height: '24px',
                padding: '0px 10px 5px',
                backgroundColor:
                  utilizationType === 'upcoming' ? '#0653fa' : undefined, // orange
                color: utilizationType === 'upcoming' ? 'white' : undefined,
                borderColor:
                  utilizationType === 'upcoming' ? '#0653fa' : undefined
              }}
              type={utilizationType === 'upcoming' ? 'default' : 'default'}
              onClick={() => setUtilizationType('upcoming')}
            >
              Upcoming
            </Button>
          </div>
        </Form.Item>
        {/* <Form.Item label="Utilization Type">
          <Checkbox.Group
            options={[
              { label: 'Active', value: 'active' },
              { label: 'Upcoming', value: 'upcoming' }
            ]}
            value={[utilizationType]} // default checked
            onChange={(checkedValues) => {
              // Ensure only one value is selected at a time
              if (checkedValues.length > 0) {
                setUtilizationType(checkedValues[checkedValues.length - 1]);
              }
            }}
          />
        </Form.Item> */}
        {/* <Form.Item label="Utilization Type">
          <Radio.Group
            value={utilizationType}
            onChange={(e) => setUtilizationType(e.target.value)}
          >
            <Radio value="active">Active</Radio>
            <Radio value="upcoming">Upcoming</Radio>
          </Radio.Group>
        </Form.Item> */}

        <div style={{ display: 'flex', justifyContent: 'center', gap: 8 }}>
          <Button
            onClick={handleCancel}
            className="font-bold border border-blue-500 text-blue-500"
          >
            Cancel
          </Button>
          <Button className="font-bold" type="primary" htmlType="submit">
            Add Member
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddMemberModal;
